<template>
  <div id="app">
    <router-view v-if="['/activation','/loginCheck'].includes($route.path)" />
    <div v-else ref="content" class="container">
      <header>
        <div class="header">
          <div class="logo-wrap">
            <div class="logo" :style="{ 'backgroundImage': 'url(' + logoUrl + ')' }" @click="toRoute('/')"></div>
          </div>
          <div class="header-right">
            <el-tabs v-model="activeTag" @tab-click="handleClick">
              <el-tab-pane label="主页" name="/"></el-tab-pane>
              <el-tab-pane label="主营业务" name="/mainbusines"></el-tab-pane>
              <el-tab-pane label="行业案例" name="/aiCase"></el-tab-pane>
              <el-tab-pane label="新闻资讯" name="/news"></el-tab-pane>
              <el-tab-pane label="公司简介" name="/extrotec"></el-tab-pane>
              <el-tab-pane label="中心简介" name="/aicenter"></el-tab-pane>
              <el-tab-pane label="联系我们" name="/new-aboutus"></el-tab-pane>
              <el-tab-pane label="加入我们" name="/joinus"></el-tab-pane>
            </el-tabs>
            <div>
              <el-button class="primaryBtn" @click="applyVisible=!applyVisible">免费试用</el-button>
            </div>
            <div>
              <el-button class="primaryBtn1" @click="goToCloud">逆熵智算云</el-button>
            </div>
          </div>
        </div>
        <spiner-div :content="spinerData" :visible="showNavgiteBar" @closeNav="closeNav"></spiner-div>
      </header>
      <main>
        <router-view ref="children"/>
      </main>
      <div class="service-wrap" v-if="$route.name != 'consult'" :style="{ 'backgroundImage' : `url(${require('@/assets/images/footterLogo.png')})`}">
        <div class="service">
          <div class="footer_container">
            <div class="footer-flex">
              <div class="footter-logo background" :style="{ 'backgroundImage' : `url(${require('@/assets/images/2025new/new-footterLogo.png')})`,'margin-right':'1rem','background-size': 'contain'}">
              </div>
              <div class="footter-middle" style="margin-top: 0.14rem;">
                <div class="item-wrap" v-for="item in footerList" :key='item.index'>
                  <div class="item-wrap-icon background"  :style="{ 'backgroundImage' : `url(${ item.img })`}"></div>
                  <div class="footer-flex" style="flex-direction: column;justify-content: space-around;">
                    <span class="item-wrap-text" style="color:#adbcbf">{{ item.label }}</span>
                    <span class="item-wrap-text">{{ item.info }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="background" style="margin-top:0.1rem">
              <div style="font-size: 0.12rem;color: #FFFFFF">中科逆熵公众号</div>
              <img src="@/assets/images/wxlogo.png" alt="" style="width:1rem;height:1rem;margin-top:0.1rem">
            </div>
          </div>
        </div>
      </div>
      <div class="num">
        <span>Copyright© 2021-2026南京中科逆熵科技有限公司版权所有 </span>
        <div :style="{ 'backgroundImage' : `url(${require('@/assets/images/police.png')})`}" style="background-repeat: no-repeat;background-size: cover;background-position: center;width:0.16rem;height:0.16rem;display:inline-block;position:relative;top:0.04rem"></div>
        <span style="color:#efefef">苏公网安备32011502012638号 </span>
        <a style="color:#efefef;" href="https://beian.miit.gov.cn/#/Integrated/index">苏ICP备2021008172号-1</a>
      </div>
      <div class="dialog" v-if="dialogVisible">
        <p class="title" :style="{ 'backgroundImage' : `url(${require('@/assets/images/concatusbj.png')})`,'width':'100%','height':'0.85rem','background-size':'cover'}">联系我们
          <i class="el-icon-close" @click="dialogVisible = false" style="float:right;cursor: pointer;margin: 0.06rem;"></i>
        </p>
        <div class="flex-center-column dialog-main">
          <div class="info"><div class="left">地址：</div><span class="right">江苏省南京市麒麟科技创新园麒麟人工智能产业园 5号楼609室</span></div>
          <div class="info"><div class="left">电话：</div><span class="right">025-52125063</span></div>
          <div class="info"><div class="left">邮箱：</div><span class="right">marketing@extrotec.com</span></div>
        </div>
      </div>
      <div class="screenBlack" v-if="dialogVisible"></div>
      <div class="dialog" v-if="applyVisible">
        <p class="title" :style="{ 'backgroundImage' : `url(${require('@/assets/images/tryapply.png')})`,'width':'100%','height':'0.85rem','background-size':'cover'}">建设智能计算生态    赋能产业发展创新
          <i class="el-icon-close" @click="applyVisible = false" style="float:right;cursor: pointer;margin: 0.06rem;"></i>
        </p>
        <div class="flex-center-column dialog-main2">
          <el-form :model="form" :rules="rules" ref="form" class="demo-ruleForm">
            <el-form-item label="需求描述：" prop="reqDesc">
              <el-input type="textarea" v-model="form.reqDesc" resize="none"></el-input>
            </el-form-item>
            <div class="flex-between">
              <div style="width: 3rem;">
                <el-form-item label="姓名：" prop="userName" >
                  <el-input v-model="form.userName"></el-input>
                </el-form-item >
              </div>
              <div style="width: 3rem;">
                <el-form-item label="电话：" prop="phone" >
                  <el-input v-model="form.phone"></el-input>
                </el-form-item>
              </div>
            </div>
            <el-form-item >
              <div style="width:100%;text-align: center;margin-top:0.12rem;">
                <el-button type="primary" @click="submitApply('form')" style="font-size: 0.14rem!important;padding:0.1rem 0.2rem !important;">立即提交</el-button>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
(function(){
  var bp = document.createElement('script');
  var curProtocol = window.location.protocol.split(':')[0];
  if (curProtocol === 'https'){
    bp.src = 'https://zz.bdstatic.com/linksubmit/push.js';
  } else {
    bp.src = 'http://push.zhanzhang.baidu.com/push.js';
  }
  var s = document.getElementsByTagName("script")[0];
  s.parentNode.insertBefore(bp, s);
})();

import userService from "@/api/api";
import spinerDiv from "@/components/spinerDiv"
export default{
  components:{ spinerDiv },
  watch:{
    '$route.path'(val){
      this.activeTag = val
      if(val == '/peripherals') this.activeTag = '/mainbusines'
      if(val == '/industryCases') this.activeTag = '/aiCase'
      this.username = localStorage.getItem('username');
    }
  },
  data(){
    return{
      applyVisible:false,
      activeTag:'',
      username: '',
      dialogVisible: false,
      showNavgiteBar:false,
      spinerData:[
        { id:0, title:'一站式AI平台赋能', contentList:[ { label:'AI建运', url:'/aiCo', type:1, isChoose:false, },{ label:'AI工厂', url:'/aiFactory', type:1, isChoose:false, },] },
        { id:1, title:'行业AI服务', contentList:[ { label:'工业自主作业支撑', url:'', type:1, isChoose:false, },{ label:'基础模型/行业模型', url:'', type:1, isChoose:false, },{ label:'AI推广普通孵化', url:'', type:1, isChoose:false, },{ label:'生态拓展', url:'https://www.handaas.com/', type:1, isChoose:false, },] },
        { id:2, title:'平台基础产品、资源线', contentList:[ { label:'ExtraMaas', url:'/extraMaas', type:1, isChoose:false, },{ label:'ExtraPaas', url:'/extraPaas', type:1, isChoose:false, },{ label:'ExtraStor', url:'/extraStor', type:1, isChoose:false, },{ label:'ExtraIaas', url:'/extraIaas', type:1, isChoose:false, },] },
      ],
      logoUrl:require('@/assets/images/2025new/logo.png'),
      footerList:[
        { info:'025-52125063', img:require('@/assets/images/2025new/footIcon1.png')},
        { info:'江苏省南京市江宁区运粮河东路701号I栋-4楼', img:require('@/assets/images/2025new/footIcon2.png')},
        { info:'marketing@extrotec.com', img:require('@/assets/images/2025new/footIcon3.png')},
      ],
      form: {
        userName: '',
        phone: '',
        reqDesc: ''
      },
      rules: {
        userName: [
          { required: true, message: '请输入名字', trigger: 'blur' },
        ],
        phone:[
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/, message: '请输入正确电话号码',},
        ],
        reqDesc: [
          { required: true, message: '请填写需求描述', trigger: 'blur' }
        ]
      }
    };
  },
  created(){
    let u = navigator.userAgent;
    let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
    let a = document.getElementById('app')
    if (isAndroid) {
      a.style = "min-width: 8rem;height: 100%;"
    } else {
      a.style = ""
    }
    this.username = localStorage.getItem('username');
  },
  methods: {
    closeNav(val){
      if(val){
        this.showNavgiteBar = false
      }
    },
    handleClick(val) {
      if(val.name == '/mainbusines'){
        this.showNavgiteBar = true
        return
      }else{
        this.showNavgiteBar = false
      }
      if(val.name=='/viewHome'){
        this.activeTag=this.$router.path
        window.open('https://ev.extrotec.com/')
        return
      }
      if(val.name != this.$route.path){
        this.$router.push( val.name)
      }
    },
    goToCloud(){
      window.open('https://ai.extrotec.com/')
    },
    toRoute(val) {
      this.$router.push(val)
    },
    submitApply(){
      this.$refs.form.validate((valid) => {
        if (valid) {
          userService.advisory({...this.form}).then(res => {
            if (res.code == 200) {
              this.$message.success('提交成功！')
              this.applyVisible=false
            }else{
              this.$message.warning(res.msg)
            }
          })
        } else {
          return false;
        }
      });
    }
  }
}
</script>

<style lang="scss">
#app {
  .el-form-item__label{
    font-size: 0.16rem;
    padding: 0 0.1rem 0 0;
  }
  .screenBlack{
    position: fixed;
    top:0;
    bottom:0;
    left:0;
    right:0;
    z-index:9999999;
    background: #141414a2;
  }
  .dialog {
    width: 6.5rem;
    min-width: 550px;
    min-height: 280px;
    position: fixed;
    top: calc(50% - 2.2rem);
    left:calc(50% - 3rem);
    box-shadow: 0 0.05rem 0.15rem 0 #14375fd6;
    border-radius: 0.06rem;
    z-index: 1000;
    background-color: #FFFFFF;
    font-size: 0.14rem;
    color: #333333;
    border-top: 0.02rem solid #0061E3;
    .title {
      color: #fff;
      font-size: 0.18rem;
      text-align: center;
      letter-spacing: 0.02rem;
      line-height: 0.85rem;
    }
    .flex-center-column{
      display: flex;
      justify-content: center;
      flex-direction: column;
    }
    .dialog-main{
      padding: 0.4rem 0.6rem;
    }
    .dialog-main2{
      padding:0.2rem;
    }
    .info {
      margin-top: 0.2rem;
      display: flex;
      justify-content: flex-start;
      width: 100%;
      .left {
        width: 0.6rem;
        font-weight: 600;
      }
    }
  }
}
.background{
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
.footer-flex{
  display: flex;
  justify-content: space-between;
}
.item-wrap{
  margin:0.16rem 0;
  display: flex;
  justify-content: flex-start;
  &-icon{
    width: 0.3rem;
    height: 0.3rem;
    position: relative;
    border-radius: 0.04rem;
    margin-right: 0.1rem;
  }
  &-text{
    font-size: 0.12rem;
    color:#efefef;
  }
}
.primaryBtn{
  font-size:0.16rem !important;
  margin: 0 0.1rem !important;
  background: #fff !important;
  color: #0061e3 !important;
  border-color: #0061E3 !important;
  border-radius:0.04rem;
}
.primaryBtn:hover{
  background-color: #0061e3 !important;
  color: #fff !important;
}
.primaryBtn1{
  font-size:0.16rem !important;
  margin: 0 0.1rem !important;
  background: #0061E3 !important;
  color: #fff !important;
  border: 0;
  border-radius:0.04rem;
}
.primaryBtn1:hover{
  background-color: #3b84e4 !important;
  color: #fff !important;
}
.service-wrap{
  width: 100%;
  height: 2.14rem;
  background: linear-gradient(to right, #DBF5FF, #2782E8);
}
.service{
  width: 12rem;
  line-height:0.32rem;
  height: 2.14rem;
  margin:0 auto;
  text-align: center;
  font-size: 0.24rem;
  font-weight: 600;
  color:#fff;
  background-repeat: no-repeat;
  background-position-y: 0.2rem;
  position:relative;
  background-size: 4rem;
  display: flex;
  justify-content: center;
  flex-direction: column;
  top:-0.1rem;
}
.logo-wrap{
  width: 2.3rem;
  height: 0.6rem;
  margin-left:0.02rem;
  z-index: 999999;
  position: relative;
}
.logo{
  background-repeat: no-repeat;
  top:0.1rem;
  left: .2rem;
  width: 2.5rem;
  height: 0.46rem;
  position: absolute;
  background-size:contain;
}
#app {
  -webkit-text-size-adjust: none !important;
}
header{
  width: 100%;
  height:0.7rem;
  background: #fff;
}
.header{
  width: 80%;
  max-width: 16rem;
  margin:0 auto;
  color:#585858;
  height:0.7rem;
  line-height: 0.7rem;
  font-size: 0.30rem;
  font-weight: 500;
  display: flex;
  justify-content: space-between;
  &-right{
    display: flex;
  }
}
main{
  width:100%;
  margin:0 auto;
  min-height: calc(100% - 3.14rem);
  background: #f5f5f5;
  font-size: 0.14rem;
}
.footer_container {
  width: 100%;
  height: 100%;
  margin: 0 auto;
  padding: 0.2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .footter-logo{
    width: 1.2rem;
    height: 1.2rem;
    margin-top: 0.3rem;
  }
}
.num {
  background-color: #171d25;
  text-align: center;
  height: 0.3rem;
  color: #c5c5c5;
  line-height: 0.3rem;
  width: 100%;
  font-size: 0.12rem;
}
.container{
  height: 100%;
  width: 100%;
}
#app{
  height: 100%;
  -webkit-font-smoothing:antialiased;
  -moz-osx-font-smoothing:grayscale;
}
.el-tabs__item{
  font-weight: 500 !important;
  padding:0 0.3rem !important;
  height:0.4rem !important;
  font-size: 0.16rem !important;
  line-height: 0.4rem !important;
}
.el-tabs__header{
  margin:0 0 0.15rem !important;
}
.el-tabs__nav-wrap:after{
  background-color:#fff !important;
}
.is-active{
  color:#333333!important
}
.el-tabs__item:hover{
  font-weight: 600!important;
  color:#333333!important
}
.dialog .el-textarea__inner{
  height: 0.64rem;
}
.dialog .el-button--primary{
  width: 3.2rem;
  height: 0.32rem;
  background: #0061E3;
  border-radius: 0.04rem;
  text-align: center;
  font-size: 0.14rem;
  font-weight: 500;
  color: #FAFBFA;
  cursor: pointer;
  margin-left: 2%;
}
.dialog .el-textarea__inner{
  background: #FAFBFA;
}
.dialog .el-input__inner{
  background: #FAFBFA;
}
.el-tabs__active-bar{
  display: none;
}
@media screen and (min-width: 2000px) {
    .el-tabs__item{
        font-size: 0.14rem !important;
    }
    .primaryBtn{
        font-size:0.13rem !important;
    }
    .service{
        font-size: 0.22rem;
    }
    .num {
        font-size: 0.1rem;
    }
    main{
        font-size: 0.13rem;
    }
}
</style>